<template>
    <div id="app">
        <div>
            <b>Selected place:</b> {{ selectedPlace || 'not chosen' }}.
            <br><br>

            <cool-select
                v-model="selectedPlace"
                :items="items"
                item-value="name"
                item-text="name">
                <template
                    slot="item"
                    slot-scope="{ item }">
                    <div style="display: flex; align-items: center;">
                        <div>
                            {{ item.offset }}
                            <b>{{ item.description}}</b>
                        </div>
                    </div>
                </template>
                <template
                    slot="selection"
                    slot-scope="{ item }">
                    <div>
                        {{ item.offset }}
                        <b>{{ item.description}}</b>
                    </div>
                </template>
            </cool-select>
        </div>
    </div>
</template>

<script>
import { CoolSelect } from 'vue-cool-select';

export default {
    name: 'auto-complete',
    components: {
        CoolSelect
    },
    props: {
        items: {
            Type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedPlace: ''
        };
    }
};
</script>

<style>

</style>
